/* eslint-disable max-len */
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import htmlParser from 'html-react-parser'

import { RadioButtonField } from '@jutro/legacy/components';
import metadata from './MLScriptComponent.metadata.json5';
import styles from './MLScriptComponent.module.scss';

import React from 'react';

function MLScriptComponent(props) {
    const {
        mlScript: lines,
        isActionContainerRequired,
        radioSelection , 
        setRadioSelection,
        isAdditionalInfo
    } = props;


    const createActionConatiner = (line) => (
    <div>
        {htmlParser(line)}
            <RadioButtonField
                availableValues={[
                    {
                      "code": "true",
                      "name": {
                        "id": "mlscriptcomponent.jutro-components.widgets.inputs.RadioButtonField.Yes",
                        "defaultMessage": "Yes"
                      }
                    },
                    {
                      "code": "false",
                      "name": {
                        "id": "mlscriptcomponent.jutro-components.widgets.inputs.RadioButtonField.No",
                        "defaultMessage": "No"
                      }
                    }
                ]}
                id="actionContainer"
                onValueChange={setRadioSelection}
                required
                value={radioSelection}
                isHorizontal
                className="vertical-spacing-20"
            />
        </div>)

    const getLine = (line) => {
        try{
            if(isActionContainerRequired && line.includes("oecradioButtonContainer")){
                return createActionConatiner(line)
            }

            return htmlParser(line)
        }catch(e){
            console.error(e);
            return line;
        }
    }

    const generateOverrides = () => {
        if (lines) {
            const overrides = lines.map((line, index) => {
                line = line.replaceAll('\n', '');
                return {
                    [`line${index}`]: {
                        content: getLine(line)
                    }
                };
            });

            return Object.assign({}, ...overrides);
        }
    };

    const overrideProps = {
        scriptContainer: {
            visible: lines && lines.length > 0
        },
        contentIterable: {
            data: lines
        },
        agentScriptHeader:{
            content:isAdditionalInfo?"eSignature Text Acknowledgement":"Agent Script"
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

MLScriptComponent.propTypes = {
    mlScript: PropTypes.array.isRequired
};

export default MLScriptComponent;
